import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { OverviewSection } from "./OverViewSection";
import TabsSection from "./TabSections";
import LeadCard from "./LeadDetailsCard";
import { useParams } from "react-router-dom";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import WSBackButton from "../../../Components/BackButton/BackButton";
import { HeaderList } from "../../../Components/Header/HeaderList";

export const LeadDetails: React.FC<any> = React.memo((props) => {
  const params = useParams();
  const [leadData, setLeadData] = useState<any>();
  const id = params?.id;
  useEffect(() => {
    async function getLeads() {
      
      const response: any = await callAPI('leads', Method.GET, null, id)
      if (response) {
        setLeadData(response)
      }

    }
    getLeads();
  }, [id])

  return (
    <Grid sx={{ backgroundColor: "#f4f4f9", minHeight: "100vh", p: 2 }}>
        {/* <HeaderList title="Leads > Details"  type="card" position="relative"  isDivider isBackButton url="/leads/list" /> */}
      {leadData && <LeadCard data={leadData} />}
      <Grid
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <Grid container spacing={2} sx={{ mt: 2,padding:1 }}>
          <Grid item xs={12} sm={8}>
            <TabsSection />
          </Grid>
          <Grid item xs={12} sm={4}>
          {leadData &&  <Sidebar data={leadData} />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
